"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Grid = styled_components_1.default.div `
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-gap: 0;

  & > :first-child {
    height: ${({ hasSecondCell }) => (hasSecondCell ? '30vh' : '100vh')};
  }

  & > :nth-child(2) {
    height: ${({ hasSecondCell }) => (hasSecondCell ? '70vh' : '0')};
  }

  @media (min-width: 1080px) {
    grid-template-columns: ${({ hasSecondCell }) => (hasSecondCell ? '1fr 1fr' : '1fr')};
    & > :first-child,
    & > :nth-child(2) {
      height: 100vh;
    }
  }

  @media (orientation: portrait) and (min-height: 1080px) {
    grid-template-columns: 1fr;
    & > :first-child {
      height: ${({ hasSecondCell }) => (hasSecondCell ? '25vh' : '100vh')};
    }
    & > :nth-child(2) {
      height: ${({ hasSecondCell }) => (hasSecondCell ? '75vh' : '0')};
    }
  }
`;
const DailyViewLayout = ({ children }) => {
    const childrenArray = react_1.default.Children.toArray(children);
    const hasSecondCell = childrenArray.length > 1 && childrenArray[1] !== null;
    return react_1.default.createElement(Grid, { hasSecondCell: hasSecondCell }, children);
};
exports.default = DailyViewLayout;
